// @flow
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import formatters from 'lib/formatters'
import styles from './AutocompleteResults.css'

type SearchResult = {
  id: String,
  line1: String,
  line2: String,
  line3: String,
  status?: String,
}

type Props = {
  query: String,
  focusedIndex: Number,
  searchType: String,
  searchResults: [SearchResult],
  onItemClick: Function,
}

function highlighLabel(label, search) {
  if (label && label.toLowerCase().includes(search.toLowerCase())) {
    return label.replace(
      search,
      `<span class="${styles.matchedText}">${search}</span>`,
    )
  }

  return label
}

const getStatusClassName = (status = '') => {
  switch (status.toLowerCase()) {
    case 'approved':
    case 'active':
      return styles.statusActive
    case 'closed':
      return styles.statusClosed
    case 'closing':
    case 'pending':
    case 'suspended':
      return styles.statusClosing
    default:
      return styles.statusDefault
  }
}

export const AutocompleteResults = ({
  query,
  searchResults,
  searchType,
  focusedIndex,
  onItemClick,
}: Props) => {
  return (
    <div className={styles.autoCompleteItems}>
      {searchResults.length > 0 && (
        <React.Fragment>
          <span className={styles.autoCompleteItems_sectionTitle}>
            {searchType}
          </span>
          <ul>
            {searchResults.map((result, idx) => (
              <li
                key={idx}
                role="button"
                className={`${idx === focusedIndex ? styles.active : ''}`}
                onClick={() => onItemClick(result.id)}
              >
                <FontAwesomeIcon
                  size="lg"
                  className={styles.autoCompleteItems_icon}
                  icon={['fas', 'user']}
                />
                <div className={styles.autoCompleteItems_label}>
                  <div className={styles.accountPrimary}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: highlighLabel(result.line1, query),
                      }}
                      className={styles.top_line}
                    />
                    {result.status && (
                      <span className={`${styles.statusBadge} ${getStatusClassName(result.status)}`}>
                        {formatters.legibleAccountStatus(result.status)}
                      </span>
                    )}
                  </div>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: highlighLabel(result.line2, query),
                    }}
                    className={styles.small}
                  />
                  {result.line3 && (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: highlighLabel(result.line3, query),
                      }}
                      className={styles.small}
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
        </React.Fragment>
      )}
    </div>
  )
}
